<template>
  <div class="rule-item">
    <div class="rule-title">{{ title }}</div>
    <div class="rule-content">{{ content }}</div>
  </div>
</template>

<script setup>

const props = defineProps({
  title: String,
  content: String,
})

const { title, content } = props
</script>

<style scoped>
.rule-item {
  margin-bottom: 24px;
  border-bottom: 1px solid #E7E8EB;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }

  .rule-title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 12px;
  }

  .rule-content {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 16px;
  }
}
</style>
